import React from "react";

interface SelectorProps {
    options: string[];
    onChange: (selected: string) => void;
}

const Selector: React.FC<SelectorProps> = ({ options, onChange }) => {
    const [rate, setRate] = React.useState("");

    const handleClick = (button: any) => {
        if (rate === "") {
            setRate(button.title);
            onChange(button);
        }
    };

    const getButtonClassName = (button: any, index: number): string => {
        if (options.length > 3) {
            if (rate === button.title) {
                if (index === 0) return "formStarfirstfilledHorizontal";
                if (index === options.length - 1) return "formStarlastfilledHorizontal";
                return "formStarfilledHorizontal";
            } else {
                if (index === 0) return "formStarfirstHorizontal";
                if (index === options.length - 1) return "formStarlastHorizontal";
                return "formStarHorizontal";
            }
        } else {
            if (rate === button.title) {
                if (index === 0) return "formStarfirstfilled";
                if (index === options.length - 1) return "formStarlastfilled";
                return "formStarfilled";
            } else {
                if (index === 0) return "formStarfirst";
                if (index === options.length - 1) return "formStarlast";
                return "formStar";
            }
        }
    };

    return (
        <div>
            <div className={options.length > 3 ? "hero-card-buttons" : "buttonsmorethan2len leftAlign"}>
                {options.map((button: any, index: number) => (
                    <button
                        onClick={() => handleClick(button)}
                        className={getButtonClassName(button, index)}
                        key={index}
                    >
                        <div className="ratenumber">{button.title}</div>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default Selector;
